export default "__VITE_ASSET__j2QivrY1__"